import * as React from 'react';

import MIPAChoiceAction from '../Common/ChoiceAction';
import MIPADatePicker from '../Common/datepicker';

import { CPlannerTask } from '../../Entity/PlannerTaskObj';

import './planner.scss';

import { IFacepilePersona } from 'office-ui-fabric-react/lib/Facepile';
import { PersonaInitialsColor, PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { IFacepileProps, OverflowButtonType } from 'office-ui-fabric-react/lib/Facepile';

import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { DirectionalHint, IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { DayOfWeek } from 'office-ui-fabric-react/lib/DatePicker';
import PlannerTaskDetails from './PlanneTaskDetails';
import TaskComments from './TaskComments';
import TaskChecklistEdit from './TaskChecklistEdit';
import TaskAssignments from './TaskAssignment';
import NewPlanTask from './newplannertask';
import TaskCategory from './TaskCategory';
import { DefaultButton, Panel } from 'office-ui-fabric-react';
import { Language } from "../../Utils/Language";
import BTICPanelContent from './BTICPanel';
import { Helper } from '../../Utils/Helper';
import { DateHelper } from "../../Helpers/DateHelper";

export interface IProps {
  data?: CPlannerTask;
  Users;
  Loadpic;
  UpdateData;
  UserEmail;
  Language;
  Header;
  Phrases;
  ReloadPlannerTasks;
  Progress;
  SMView?: boolean;
  APIHeader;
  APIServiceurl;
  CurrentUser;
}
export interface IContextualMenuState {
  directionalHint?: DirectionalHint;
  directionalHintForRTL?: DirectionalHint;
  useDirectionalHintForRtl?: boolean;
  isBeakVisible?: boolean;
  gapSpace?: number;
  beakWidth?: number;
  edgeFixed?: boolean;
  isCalloutVisible?: boolean;
  firstDayOfWeek?: DayOfWeek;
  ShowNewPlanTaskWindow: boolean;
  isBTICPanelOpen: boolean;
}

/*const baseProductionCdnUrl = 'https://static2.sharepointonline.com/files/fabric/office-ui-fabric-react-assets/';
const TestImages = {
  choiceGroupBarUnselected: baseProductionCdnUrl + 'choicegroup-bar-unselected.png',
  choiceGroupBarSelected: baseProductionCdnUrl + 'choicegroup-bar-selected.png',
  choiceGroupPieUnselected: baseProductionCdnUrl + 'choicegroup-pie-unselected.png',
  choiceGroupPieSelected: baseProductionCdnUrl + 'choicegroup-pie-selected.png',
  documentPreview: baseProductionCdnUrl + 'document-preview.png',
  documentPreviewTwo: baseProductionCdnUrl + 'document-preview2.png',
  documentPreviewThree: baseProductionCdnUrl + 'document-preview3.png',
  iconOne: baseProductionCdnUrl + 'icon-one.png',
  iconPpt: baseProductionCdnUrl + 'icon-ppt.png',
  personaFemale: baseProductionCdnUrl + 'persona-female.png',
  personaMale: baseProductionCdnUrl + 'persona-male.png'
};*/
const facepilePersonas: IFacepilePersona[] = [
  /*{
    imageUrl: TestImages.personaFemale,
    personaName: 'Annie Lindqvist',
    data: '50%'
  },
  {
    imageUrl: TestImages.personaFemale,
    personaName: 'Aaron Reid',
    data: '$1,000'
  },
  {
    personaName: 'Alex Lundberg',
    data: '75%',
    onClick: (ev: React.MouseEvent<HTMLElement>, persona: IFacepilePersona) =>
      alert('You clicked on ' + persona.personaName + '. Extra data: ' + persona.data)
  },
  {
    personaName: 'Roko Kolar',
    data: '4 hrs'
  },
  {
    imageInitials: 'CB',
    personaName: 'Christian Bergqvist',
    initialsColor: PersonaInitialsColor.green,
    data: '25%'
  },
  {
    imageUrl: TestImages.personaFemale,
    imageInitials: 'VL',
    personaName: 'Valentina Lovric',
    initialsColor: PersonaInitialsColor.lightBlue,
    data: 'Emp1234',
    onClick: (ev: React.MouseEvent<HTMLElement>, persona: IFacepilePersona) =>
      alert('You clicked on ' + persona.personaName + '. Extra data: ' + persona.data)
  },
  {
    imageUrl: TestImages.personaMale,
    imageInitials: 'MS',
    personaName: 'Maor Sharett',
    initialsColor: PersonaInitialsColor.lightGreen
  },
  {
    imageUrl: TestImages.personaFemale,
    imageInitials: 'PV',
    personaName: 'Annie Lindqvist2',
    initialsColor: PersonaInitialsColor.lightPink
  },
  {
    imageUrl: TestImages.personaMale,
    imageInitials: 'AR',
    personaName: 'Aaron Reid2',
    initialsColor: PersonaInitialsColor.magenta,
    data: 'Emp1234',
    onClick: (ev: React.MouseEvent<HTMLElement>, persona: IFacepilePersona) =>
      alert('You clicked on ' + persona.personaName + '. Extra data: ' + persona.data)
  },
  {
    imageUrl: TestImages.personaMale,
    imageInitials: 'AL',
    personaName: 'Alex Lundberg2',
    initialsColor: PersonaInitialsColor.orange
  },
  {
    imageUrl: TestImages.personaMale,
    imageInitials: 'RK',
    personaName: 'Roko Kolar2',
    initialsColor: PersonaInitialsColor.pink
  },
  {
    imageUrl: TestImages.personaMale,
    imageInitials: 'CB',
    personaName: 'Christian Bergqvist2',
    initialsColor: PersonaInitialsColor.purple
  },
  {
    imageUrl: TestImages.personaFemale,
    imageInitials: 'VL',
    personaName: 'Valentina Lovric2',
    initialsColor: PersonaInitialsColor.red
  },
  {
    imageUrl: TestImages.personaMale,
    imageInitials: 'MS',
    personaName: 'Maor Sharett2',
    initialsColor: PersonaInitialsColor.teal
  },
  {
    imageUrl: TestImages.personaFemale,
    imageInitials: 'VL',
    personaName: 'Another A Name',
    initialsColor: PersonaInitialsColor.blue
  },
  {
    imageUrl: TestImages.personaMale,
    imageInitials: 'MS',
    personaName: 'Another A Name (So Many A names!)',
    initialsColor: PersonaInitialsColor.darkBlue
  },
  {
    imageUrl: TestImages.personaFemale,
    imageInitials: 'VL',
    personaName: 'Another Anecdotal A Name',
    initialsColor: PersonaInitialsColor.darkGreen
  },
  {
    imageUrl: TestImages.personaMale,
    imageInitials: 'MS',
    personaName: 'Anerobic A Name',
    initialsColor: PersonaInitialsColor.darkRed
  },
  {
    imageUrl: TestImages.personaFemale,
    imageInitials: 'VL',
    personaName: 'Aerobic A Name',
    initialsColor: PersonaInitialsColor.green
  },
  {
    imageUrl: TestImages.personaMale,
    imageInitials: 'MS',
    personaName: 'Maor Sharett2',
    initialsColor: PersonaInitialsColor.lightBlue
  },
  {
    imageUrl: TestImages.personaFemale,
    imageInitials: 'VL',
    personaName: 'Valentina Lovric2',
    initialsColor: PersonaInitialsColor.lightGreen
  },
  {
    imageUrl: TestImages.personaMale,
    imageInitials: 'MS',
    personaName: 'Maor Sharett2',
    initialsColor: PersonaInitialsColor.lightPink
  },
  {
    imageUrl: TestImages.personaFemale,
    imageInitials: 'VL',
    personaName: 'Valentina Lovric2',
    initialsColor: PersonaInitialsColor.magenta
  },
  {
    imageUrl: TestImages.personaMale,
    imageInitials: 'MS',
    personaName: 'Maor Sharett2',
    initialsColor: PersonaInitialsColor.orange
  }*/
];

export default class PlannerTask extends React.Component<IProps, IContextualMenuState> {
  public facepileProps: IFacepileProps = {
    personas: facepilePersonas,
    maxDisplayablePersonas: 5,
    overflowButtonType: OverflowButtonType.none,
    overflowButtonProps: {
      ariaLabel: 'More users',
      onClick: (ev: React.MouseEvent<HTMLButtonElement>) => alert('overflow icon clicked')
    },
    ariaDescription: 'To move through the items use left and right arrow keys.'
  };
  public facepilePropsAssignedby: IFacepileProps = {
    personas: facepilePersonas,
    maxDisplayablePersonas: 5,
    overflowButtonType: OverflowButtonType.none,
    overflowButtonProps: {
      ariaLabel: 'More users',
      onClick: (ev: React.MouseEvent<HTMLButtonElement>) => alert('overflow icon clicked')
    },
    ariaDescription: 'To move through the items use left and right arrow keys.'
  };
  public facepilePropsCreatedBy: IFacepileProps = {
    personas: facepilePersonas,
    maxDisplayablePersonas: 5,
    overflowButtonType: OverflowButtonType.none,
    overflowButtonProps: {
      ariaLabel: 'More users',
      onClick: (ev: React.MouseEvent<HTMLButtonElement>) => alert('overflow icon clicked')
    },
    ariaDescription: 'To move through the items use left and right arrow keys.'
  };

  constructor(props: IProps) {
    super(props);
    this.state = {
      isCalloutVisible: false,
      directionalHint: DirectionalHint.topCenter,
      beakWidth: 16,
      firstDayOfWeek: DayOfWeek.Monday,
      ShowNewPlanTaskWindow: false,
      isBTICPanelOpen: false
    };
  }

  // UserEmail.split("@")[1]
  public render() {
    // let assignecount = 0;
    this.facepileProps.personas = [];
    this.facepilePropsAssignedby.personas = [];
    this.facepilePropsCreatedBy.personas = [];
    // for (let assignedTo in this.props.data.assignments) {
    let assignedby = [];
    Object.keys(this.props.data.assignments).map((assignedTo) => {

      if (this.props.data.assignments[assignedTo] && this.props.data.assignments[assignedTo].assignedBy && this.props.data.assignments[assignedTo].assignedBy.user) {
        if (this.props.data.assignments[assignedTo].assignedBy.user.id && assignedby.indexOf(this.props.data.assignments[assignedTo].assignedBy.user.id) < 0) {
          assignedby.push(this.props.data.assignments[assignedTo].assignedBy.user.id);
        }
      }
      let user = this.props.Users.filter(u => u.id == assignedTo);

      if (user && user.length > 0) {
        user = user[0];
        // assignecount++;
        if (user.surname == null) {
          user.surname = user.givenName;
        }
        let AssingeeInitial = user.givenName != null ? user.givenName.trim().substr(0, 1).toUpperCase() + user.surname.trim().substr(0, 1).toUpperCase() : user.displayName.trim().substr(0, 2).toUpperCase();
        let persion = {
          //imageUrl: 'https://cdn1.iconfinder.com/data/icons/user-pictures/100/male3-512.png',
          imageUrl: Helper.GetDefaultImage(),
          imageInitials: AssingeeInitial,
          personaName: user.displayName,
          initialsColor: PersonaInitialsColor.magenta
        };

        if (user.imagepath == null || user.imagepath == '') {
          this.props.Loadpic(user.id);
        } else {
          persion.imageUrl = user.imagepath;
        }
        this.facepileProps.personas.push(persion);
        this.facepileProps.personaSize = PersonaSize.size24;
        // plan=myPlanList.filter(p=> p.id==item.planId);
      }

    });
    assignedby.forEach(assignedby => {
      let user = this.props.Users.filter(u => u.id == assignedby);

      if (user && user.length > 0) {
        user = user[0];
        // assignecount++;
        if (user.surname == null) {
          user.surname = user.givenName;
        }
        let AssingeeInitial = user.givenName != null ? user.givenName.trim().substr(0, 1).toUpperCase() + user.surname.trim().substr(0, 1).toUpperCase() : user.displayName.trim().substr(0, 2).toUpperCase();
        let persion = {
          //imageUrl: 'https://cdn1.iconfinder.com/data/icons/user-pictures/100/male3-512.png',
          imageUrl: Helper.GetDefaultImage(),
          imageInitials: AssingeeInitial,
          personaName: user.displayName,
          initialsColor: PersonaInitialsColor.magenta
        };

        if (user.imagepath == null || user.imagepath == '') {
          this.props.Loadpic(user.id);
        } else {
          persion.imageUrl = user.imagepath;
        }
        this.facepilePropsAssignedby.personas.push(persion);
        this.facepilePropsAssignedby.personaSize = PersonaSize.size24;
        // plan=myPlanList.filter(p=> p.id==item.planId);
      }
    });
    if (this.props.data.createdBy && this.props.data.createdBy.user && this.props.data.createdBy.user.id) {
      let user = this.props.Users.filter(u => u.id == this.props.data.createdBy.user.id);

      if (user && user.length > 0) {
        user = user[0];
        // assignecount++;
        if (user.surname == null) {
          user.surname = user.givenName;
        }
        let AssingeeInitial = user.givenName != null ? user.givenName.trim().substr(0, 1).toUpperCase() + user.surname.trim().substr(0, 1).toUpperCase() : user.displayName.trim().substr(0, 2).toUpperCase();
        let persion = {
          //imageUrl: 'https://cdn1.iconfinder.com/data/icons/user-pictures/100/male3-512.png',
          imageUrl: Helper.GetDefaultImage(),
          imageInitials: AssingeeInitial,
          personaName: user.displayName,
          initialsColor: PersonaInitialsColor.magenta
        };

        if (user.imagepath == null || user.imagepath == '') {
          this.props.Loadpic(user.id);
        } else {
          persion.imageUrl = user.imagepath;
        }
        this.facepilePropsCreatedBy.personas.push(persion);
        this.facepilePropsCreatedBy.personaSize = PersonaSize.size24;
        // plan=myPlanList.filter(p=> p.id==item.planId);
      }
    }
    let rowcss = "ms-Grid-row miparow";
    let linkInfo = <span>&nbsp;</span>;
    let checkitems = <span>&nbsp;</span>;
    let comments = <span>&nbsp;</span>;
    let startstatus = (
      <MIPAChoiceAction contextbuttoncss='contextbutton' items={this.PrepareProgressStatusList()}>
        {this.props.data.percentComplete == 0 ? <i title={this.props.Phrases.notstarted} className="ms-Icon ms-Icon--CircleRing" /> :
          <i title={this.props.Phrases.inprogress} className="ms-Icon ms-Icon--CircleHalfFull" />}
      </MIPAChoiceAction>
    );
    /*let startstatus1 = this.props.data.percentComplete == 0 ? <i title={this.props.Phrases.notstarted} className="ms-Icon ms-Icon--CircleRing" /> :
                                                             <i title={this.props.Phrases.inprogress} className="ms-Icon ms-Icon--CircleHalfFull" />;*/
    if (this.props.data.referenceCount > 0) {
      linkInfo = (
        <span title={this.props.Phrases.attachmentcount.replace('{0}', this.props.data.referenceCount)}>
          <i className="ms-Icon ms-Icon--Attach" />
          <label style={{ fontSize: '14px', display: 'inline-block', marginTop: '-8px' }}>
            {this.props.data.referenceCount}
          </label>
        </span>
      );
    }
    if (this.props.data.checklistItemCount && this.props.data.checklistItemCount > 0) {

      let rem = parseInt(this.props.data.checklistItemCount, 0) - parseInt(this.props.data.activeChecklistItemCount, 0) + '/' + this.props.data.checklistItemCount;
      checkitems = (
        <TaskChecklistEdit
          data={this.props.data}
          title={this.props.Phrases.completedcount.replace('{0}', rem)}
          Header={this.props.Header}
          Phrases={this.props.Phrases}
          rem={rem}
          ReloadPlannerTasks={this.props.ReloadPlannerTasks}
          Progress={this.props.Progress}
        />
      );
      // checkitems = <span title={this.props.Phrases.completedcount.replace('{0}',rem)}><i className="ms-Icon ms-Icon--CheckboxComposite"></i><label style={{ fontSize: '14px', marginLeft: '2px', display: 'inline-block', marginTop: '-8px' }}>{rem}</label> </span>;
    }
    //if (this.props.data.conversationThreadId != null) 
    {
      comments = (
        <div
          title={this.props.Phrases.showcomments}
          style={{ float: 'right', fontSize: '18px', marginRight: '10px' }}
        >
          <TaskComments
            data={this.props.data}
            Users={this.props.Users}
            Header={this.props.Header}
            Phrases={this.props.Phrases}
            Progress={this.props.Progress}
            ThreadId={this.props.data.conversationThreadId}
            ReloadPlannerTasks={this.props.ReloadPlannerTasks}
            CurrentUser={this.props.CurrentUser}
          />
        </div>);
    }
    let webpartbody = this.props.data.col < 0 ? ['webpartbody', 'overdue'].join(' ') : 'webpartbody';
    let editurl = this.props.UserEmail.split("@")[1] + "/" + this.props.Language + "/Home/Task/";
    editurl = 'https://tasks.office.com/' + editurl + this.props.data.id;
    let categoryui = null;
    let cats = this.props.data.appliedCategories;
    if (cats) {
      categoryui = [];
      let catcss = 'task-details-category-tabdisplay checkIcon ms-Icon';
      if (cats.category1) {
        categoryui.push(<i key="cat1" className={[catcss, 'category1'].join(" ")} />);
      }
      if (cats.category2) {
        categoryui.push(<i key="cat2" className={[catcss, 'category2'].join(" ")} />);
      }
      if (cats.category3) {
        categoryui.push(<i key="cat3" className={[catcss, 'category3'].join(" ")} />);
      }
      if (cats.category4) {
        categoryui.push(<i key="cat4" className={[catcss, 'category4'].join(" ")} />);
      }
      if (cats.category5) {
        categoryui.push(<i key="cat5" className={[catcss, 'category5'].join(" ")} />);
      }
      if (cats.category6) {
        categoryui.push(<i key="cat6" className={[catcss, 'category6'].join(" ")} />);
      }
      categoryui.push(<div className="mtb8" style={{ "clear": 'both', 'marginBottom': '5px' }} />);
    }
    let pririty = [];
    switch (this.props.data.priority) {
      case 0:
      case 1:
        pririty.push(<i className="ms-Icon ms-Icon--Ringer color-urgent prirityicon" />);
        pririty.push(<span className="prioritylable">{this.props.Phrases.urgent}</span>);
        break;
      case 2:
      case 3:
      case 4:
        pririty.push(<i className="ms-Icon ms-Icon--Important color-important prirityicon" key="" />);
        pririty.push(<span className="prioritylable">{this.props.Phrases.important}</span>);
        break;
      case 5:
      case 6:
      case 7:
        pririty.push(<i className="ms-Icon ms-Icon--LocationDot color-medium prirityicon" key={this.props.data.priority} />);
        pririty.push(<span className="prioritylable" key="prioritylable">{this.props.Phrases.medium}</span>);
        break;
      case 8:
      case 9:
      case 10:
        pririty.push(<i className="ms-Icon ms-Icon--Down color-low prirityicon" />);
        pririty.push(<span className="prioritylable">{this.props.Phrases.low}</span>);
        break;
      default:
        break;
    }

    let duedate = this.props.data.dueDateTime != null ? this.props.data.dueDateTime.toString() : '';

    return (

      <div className='webpart' >
        <div className='webpartTitle'>
          <i className="ms-Icon ms-Icon--PlannerLogo" />
          {this.props.SMView ? '' : this.props.Phrases.title}
          {/* <a className='openlink' title={this.props.Phrases.edit} href={editurl} target="_blank">
            <i className="ms-Icon ms-Icon--EditSolid12" />
          </a> */}
          <i title='Edit' className="ms-Icon ms-Icon--EditSolid12 openlink" onClick={() => { this.setState({ ShowNewPlanTaskWindow: true }); }} />
        </div>
        <div className={webpartbody}>
          <div className="ms-Grid">
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                <PlannerTaskDetails
                  data={this.props.data}
                  Header={this.props.Header}
                  Users={this.props.Users}
                  facepileProps={this.facepileProps}
                  //facepilePropsAssignedby={this.facepilePropsAssignedby}
                  Phrases={this.props.Phrases}
                  UpdatePlannerTask={this.UpdatePlannerTask}
                /* Progress={this.props.Progress} */
                />
              </div>
            </div>
            <div className={this.props.SMView ? "hide" : rowcss}>
              <div className='ms-Grid-col ms-sm12'>
                <TaskCategory
                  AddCategoryMethod={(newcat: any) => {
                    this.UpdatePlannerTask({ 'appliedCategories': newcat });
                  }}
                  Phrases={this.props.Phrases}
                  appliedCategories={this.props.data.appliedCategories}
                  categoryDescriptions={[]}
                />
              </div>
            </div>
            <div className={rowcss}>
              <div className={this.props.SMView ? "ms-Grid-col ms-sm12" : "ms-Grid-col ms-sm6"}>
                <div title={this.props.data.planeName} className={['graytext', 'ellips'].join(' ')}>{this.props.data.planeName}</div>
              </div>
              <div className={this.props.SMView ? "ms-Grid-col ms-sm12" : "ms-Grid-col ms-sm6"}>
                <MIPAChoiceAction contextbuttoncss='contextbutton' items={this.PrepareBucketItems()}>
                  <div title={this.props.data.bucketName} className={['bucket', 'ellips'].join(' ')}>{this.props.data.bucketName}</div>
                </MIPAChoiceAction>
              </div>

            </div>
            <div className={rowcss}>
              <div className={this.props.SMView ? "ms-Grid-col ms-sm12" : "ms-Grid-col ms-sm6"}>
                <div className={this.props.SMView ? 'dateleft ellips' : 'dateleft'}
                  //title={this.props.Phrases.setduedate}
                  title={this.props.SMView ? duedate : this.props.Phrases.setduedate}
                >
                  <MIPADatePicker
                    datevalue={duedate}
                    ChangeDate={(date) => {
                      let newobj={ dueDateTime: date };
                      if(this.props.data.startDateTime){
                        let startdateDate = new Date(this.props.data.startDateTime);
                        startdateDate = DateHelper.SetTimeToDate(startdateDate, 0, 0, 0);
                        let duedateDate = new Date(date);
                        duedateDate = DateHelper.SetTimeToDate(duedateDate, 0, 0, 0);
                        if(startdateDate>duedateDate){
                          
                          newobj["startDateTime"]=date;
                        }
                      }
                       
                      this.UpdatePlannerTask(newobj);
                    }} />
                </div>
              </div>
              <div className={this.props.SMView ? "hide" : "ms-Grid-col ms-sm6"}>
                <div className='linkinfocontainer'>
                  {startstatus} {linkInfo} {checkitems}
                </div>
              </div>
            </div>

            <div className="rowcss">
              <div className={this.props.SMView ? "ms-Grid-col ms-sm12 todo-taskboard-priority" : "ms-Grid-col ms-sm6 todo-taskboard-priority"}>
                <MIPAChoiceAction contextbuttoncss='contextbutton' items={this.PreparePriorityItems()}>
                  {pririty}
                </MIPAChoiceAction>

              </div>
              {/* <div className={this.props.SMView?"hide":"ms-Grid-col ms-sm6"} >
                <TaskCategory AddCategoryMethod={(newcat)=>{
                  this.UpdatePlannerTask({ 'appliedCategories':newcat });
                }} Phrases={this.props.Phrases}
                appliedCategories={this.props.data.appliedCategories}
                categoryDescriptions={{}}
                />
                {categoryui}
              </div> */}
            </div>
            <div className="rowcss">
              <div className="ms-Grid-col ms-sm12">
                <div className='assignecontainer'>
                  {/* <Facepile {...this.facepileProps} /> */}
                  <TaskAssignments
                    data={this.props.data}
                    Users={this.props.Users}
                    facepileProps={this.facepileProps}
                    facepilePropsAssignedby={this.props.SMView ? [] : this.facepilePropsAssignedby}
                    facepilePropsCreatedBy={this.props.SMView ? [] : this.facepilePropsCreatedBy}
                    Header={this.props.Header}
                    Phrases={this.props.Phrases}
                    ReloadPlannerTasks={this.props.ReloadPlannerTasks}
                    Progress={this.props.Progress}
                    Loadpic={this.props.Loadpic}
                  />
                </div>
              </div>
            </div>
            <div className='rowcss btic-row'>
              <div className='mg-Grid-col ms-sm12'>
                <DefaultButton className='btn-plnr-default btn-block m-5-0' onClick={() => { this.setState({ isBTICPanelOpen: true }); }}>
                  <span className='normaltext'>{Language.GetLanguageValue(this.props.Language, 'booktimeinyourcalendar')}</span>
                  <span className="overtext">{Language.GetLanguageValue(this.props.Language, 'book')}</span>
                </DefaultButton>
              </div>
              <div className='mg-Grid-col ms-sm12'>
              <Panel
                headerText=''
                isOpen={this.state.isBTICPanelOpen}
                onDismiss={() => { this.setState({ isBTICPanelOpen: false }); }}
                closeButtonAriaLabel="Close">
                <BTICPanelContent 
                  CurrentUser={this.props.CurrentUser}
                  dismisBTICPanel={this.DismissBTICPanel} 
                  data={this.props.data} 
                  Language={this.props.Language} 
                  DueDate={new Date()} 
                  Time={'08:00 AM'} 
                  Duration={'30'}
                  Progress={this.props.Progress}
                  Header={this.props.Header} />
              </Panel>
              </div>
            </div>
          </div>
        </div>
        <div className='webpartfooter'>
          <div className="ms-Grid-col ms-sm6">
            <Checkbox
              title={this.props.Phrases.markcomplete}
              className='checkbox'
              label={this.props.SMView ? '' : this.props.Phrases.markcomplete}
              onChange={() => {
                this.UpdatePlannerTask({ percentComplete: 100 });
                // this.UpdateMeetingValue(this.props.meeting.ID,null,'MeetRepFollow','DateTime',this.props.meeting.MeetingColmn);
              }}
            />
          </div>
          <div className="ms-Grid-col ms-sm6">
            {comments}
          </div>


        </div>
        {this.state.ShowNewPlanTaskWindow ? <NewPlanTask
          closeMethod={(reload) => {
            this.setState({ ShowNewPlanTaskWindow: false });
            if (reload) {
              this.props.ReloadPlannerTasks(0, this.props.data.planId);
            }
          }}
          plans={[]}
          GraphHeader={this.props.Header}
          Phrases={this.props.Phrases}
          Users={this.props.Users}
          Loadpic={this.props.Loadpic}
          UserEmail={this.props.UserEmail}
          APIHeader={this.props.APIHeader}
          APIServiceurl={this.props.APIServiceurl}
          //flagemailfortask={this.flagemailfortask}
          Updatetask={this.props.UpdateData}
          CurrenttaskTask={this.props.data}
        /> : null}
      </div>


    );
  }
  public PrepareBucketItems(): IContextualMenuItem[] {
    let menus = [];
    let keyIndex = 0;
    if (this.props.data.buckets != null) {
      this.props.data.buckets.forEach((element) => {
        let menu = {
          key: 'buckets_' + this.props.data.id + "_" + keyIndex,
          name: element.name,
          iconProps: {
            className: this.props.data.bucketId == element.id ? 'ms-Icon ms-Icon--RadioBtnOn' : 'ms-Icon ms-Icon--RadioBtnOff'
          },
          onClick: () => {
            if (this.props.data.bucketId != element.id) {
              this.UpdatePlannerTask({ 'bucketId': element.id });
            }
            //this.UpdateSSOValue(this.props.data.ID,element.id,'IGlobeCRM_SSO_Pipeline','Choice',this.props.data.SSOColmn);
          }
        };
        keyIndex++;
        menus.push(menu);
      });
    }

    return menus;
  }
  public PreparePriorityItems(): IContextualMenuItem[] {

    let menus = [];
    menus.push(
      {
        key: 'priority_urgent',
        name: this.props.Phrases.urgent,
        iconProps: {
          className: [0, 1].indexOf(this.props.data.priority) >= 0 ? 'ms-Icon ms-Icon--RadioBtnOn' : 'ms-Icon ms-Icon--RadioBtnOff'
        },
        onClick: () => {
          if ([0, 1].indexOf(this.props.data.priority) < 0) {
            //this.UpdatePlannerTaskbeta({ 'priority':1 });
            this.UpdatePlannerTask({ 'priority': 1 });
          }
        }
      }
    );
    menus.push(
      {
        key: 'priority_important',
        name: this.props.Phrases.important,
        iconProps: {
          className: [2, 3, 4].indexOf(this.props.data.priority) >= 0 ? 'ms-Icon ms-Icon--RadioBtnOn' : 'ms-Icon ms-Icon--RadioBtnOff'
        },
        onClick: () => {
          if ([2, 3, 4].indexOf(this.props.data.priority) < 0) {
            //this.UpdatePlannerTaskbeta({ 'priority':4 });
            this.UpdatePlannerTask({ 'priority': 4 });
          }
        }
      }
    );
    menus.push(
      {
        key: 'priority_medium',
        name: this.props.Phrases.medium,
        iconProps: {
          className: [5, 6, 7].indexOf(this.props.data.priority) >= 0 ? 'ms-Icon ms-Icon--RadioBtnOn' : 'ms-Icon ms-Icon--RadioBtnOff'
        },
        onClick: () => {
          if ([5, 6, 7].indexOf(this.props.data.priority) < 0) {
            //this.UpdatePlannerTaskbeta({ 'priority':7 });
            this.UpdatePlannerTask({ 'priority': 7 });
          }
        }
      }
    );
    menus.push(
      {
        key: 'priority_low',
        name: this.props.Phrases.low,
        iconProps: {
          className: [8, 9, 10].indexOf(this.props.data.priority) >= 0 ? 'ms-Icon ms-Icon--RadioBtnOn' : 'ms-Icon ms-Icon--RadioBtnOff'
        },
        onClick: () => {
          if ([8, 9, 10].indexOf(this.props.data.priority) < 0) {
            //this.UpdatePlannerTaskbeta({ 'priority':9 });
            this.UpdatePlannerTask({ 'priority': 9 });
          }
        }
      }
    );
    return menus;
  }
  public PrepareProgressStatusList(): IContextualMenuItem[] {

    let menus = [];
    menus.push(
      {
        key: 'status_notstarted',
        name: this.props.Phrases.notstarted,
        iconProps: {
          className: this.props.data.percentComplete == 0 ? 'ms-Icon ms-Icon--RadioBtnOn' : 'ms-Icon ms-Icon--RadioBtnOff'
        },
        onClick: () => {
          if (this.props.data.percentComplete != 0) {
            this.UpdatePlannerTask({ 'percentComplete': 0 });
          }
        }
      }
    );
    menus.push(
      {
        key: 'status_inprogress',
        name: this.props.Phrases.inprogress,
        iconProps: {
          className: this.props.data.percentComplete > 0 && this.props.data.percentComplete < 100 ? 'ms-Icon ms-Icon--RadioBtnOn' : 'ms-Icon ms-Icon--RadioBtnOff'
        },
        onClick: () => {
          if (this.props.data.percentComplete != 50) {
            this.UpdatePlannerTask({ 'percentComplete': 50 });
          }
        }
      }
    );
    menus.push(
      {
        key: 'status_completed',
        name: this.props.Phrases.completed,
        iconProps: {
          className: this.props.data.percentComplete == 100 ? 'ms-Icon ms-Icon--RadioBtnOn' : 'ms-Icon ms-Icon--RadioBtnOff'
        },
        onClick: () => {
          if (this.props.data.percentComplete != 100) {
            this.UpdatePlannerTask({ 'percentComplete': 100 });
          }
        }
      }
    );
    return menus;
  }

  public UpdatePlannerTask = (obj) => {
    this.props.UpdateData(this.props.data.id, obj, this.props.data['@odata.etag'], this.props.data.col);
  }
  public UpdatePlannerTaskbeta = (obj) => {
    this.props.UpdateData(this.props.data.id, obj, this.props.data['@odata.etag'], this.props.data.col, true);

  }
  public DismissBTICPanel = () => {
    this.setState({ isBTICPanelOpen: false });
  }
}
